import ColorRowPreview from './ColorRowPreview'
export type { ColorRowPreviewProps } from './ColorRowPreview'
export default ColorRowPreview
